module.exports = __webpack_public_path__ + "media/images/lb/669-ee074c119b6be739cf3e906ecb94a973.svg";